<template>
  <div>

    <el-dialog
      :title="title"
      :visible="visible"
      @close="closeDialog"
      @open="create"
      width="60%"
    >
      <form autocomplete="off" @submit.prevent="onSubmit">
        <div class="form-body">

          <div class="row">
            <div
                class="col-6 col-md-4 form-group"
                :class="{ 'has-danger': errors.duration }"
            >
                <label for="duration">Cant. noches</label>
                <el-input-number
                    v-model="form.duration"
                    controls-position="right"
                    @change="updateDuration"
                    :min="1"
                ></el-input-number>
                <small
                    class="form-control-feedback"
                    v-if="errors.duration"
                    v-text="errors.duration[0]"
                ></small>
            </div>
            <div
                class="col-6 col-md-4 form-group"
                :class="{ 'has-danger': errors.output_date }"
            >
                <label>Fecha de salida</label>
                <el-date-picker
                    v-model="form.output_date"
                    type="date"
                    placeholder="Seleccione una fecha"
                    value-format="yyyy-MM-dd"
                    readonly
                ></el-date-picker>
                <small
                    class="form-control-feedback"
                    v-if="errors.output_date"
                    v-text="errors.output_date[0]"
                ></small>
            </div>
            <div
                class="col-6 col-md-4 form-group"
                :class="{ 'has-danger': errors.output_time }"
            >
                <label>Hora de salida</label>
                <el-input v-model="form.output_time" placeholder="HH:MM">
                </el-input>
                <small
                    class="form-control-feedback"
                    v-if="errors.output_time"
                    v-text="errors.output_time[0]"
                ></small>
            </div>
          </div>

          <div class="row text-center">
            <div class="col-6">
              <el-button
                native-type="submit"
                type="primary"
                class="btn-block"
                :disabled="loading"
                >Guardar</el-button
              >
            </div>
            <div class="col-6">
              <el-button class="btn-block" @click="closeDialog">Cancelar</el-button>
            </div>
          </div>
        </div>
      </form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['room','visible'],
  data() {
    return {
      form: {
        output_date: moment().format("YYYY-MM-DD"),
        output_time: moment().format("HH:mm:ss"),
        duration: 1
      },
      showDialog: false,
      title: 'Editar Estadía',
      errors: {},
      loading: false,
      item: {},
      sale_note: {}
    }
  },
  methods: {
    initForm(){
      this.form = {
        output_date: moment().format("YYYY-MM-DD"),
        output_time: moment().format("HH:mm:ss"),
        duration: 1,
        item: {}
      }
      this.item = {}
    },
    closeDialog() {
      this.initForm()
      this.$emit("onRefresh")
      this.$emit("update:visible", false)
    },
    async create() {

      // console.log(this.room)
      this.form = {
        output_date: this.room.rent.output_date,
        output_time: this.room.rent.output_time,
        duration: this.room.rent.duration
      }
    },
    updateDuration() {
      const newDate = moment().add(this.form.duration, "days")
      this.form.output_date = newDate.format("YYYY-MM-DD")
      // this.getItem()
    },
    getItem() {
      this.$http
          .get(`/hotels/reception/${this.room.rent.id}/rent/get-item`)
          .then(response => {
            this.item = response.data.item
            this.changeJsonItem()
          })
    },
    changeJsonItem() {
      //calcular los cambios aqui, actualizar el json y enviar al form
      let quantity = this.form.duration
      let percentage_igv = this.item.percentage_igv
      let unit_price = this.item.unit_price
      let total = quantity * unit_price
      let total_base_igv = total / (1 + (percentage_igv / 100))
      let total_igv = total - total_base_igv

      this.item.quantity = quantity
      this.item.total = _.round(total, 2)
      this.item.total_base_igv = _.round(total_base_igv, 2)
      this.item.total_value = _.round(total_base_igv, 2)
      this.item.total_taxes = _.round(total_igv, 2)
      this.item.total_igv = _.round(total_igv, 2)

      this.item.total_value_without_rounding = total_base_igv
      this.item.total_base_igv_without_rounding = total_base_igv
      this.item.total_igv_without_rounding = total_igv
      this.item.total_taxes_without_rounding = total_igv
      this.item.total_without_rounding = total


      this.form.item = this.item
    },
    async onSubmit() {
      try {
        this.loading = true
        const response = await this.$http.get(`/hotels/reception/${this.room.rent.id}/rent/get-item`)
        this.item = response.data.item
        this.changeJsonItem()
        const { sale_note_id } = response.data
        if (sale_note_id) {
          const res = await this.$http.get(`/sale-notes/record2/${sale_note_id}`)
          this.sale_note = res.data.data
          this.sale_note.items = []
          this.sale_note.items = [this.item]
          this.calculateTotal()
          this.recalculatePayments()

          const response_save = await this.$http.post(`/sale-notes`, this.sale_note)
          if (response_save.data.success) {
              const { id, cash_id } = response_save.data.data
              this.$message({
                  message: 'Nota de venta editada correctamente',
                  type: 'success',
              })
              await this.saveCashDocument(id, cash_id)
          } else {
              console.log('Error al guardar la nota de venta')
          }
        }
  
        const resp = await this.$http.post(`/hotels/reception/${this.room.rent.id}/rent/extend-time`, this.form)
        this.$message.success(resp.data.message)
        this.closeDialog()
      } catch (error) {
        this.axiosError(error)
      } finally {
        this.loading = false
      }
    },

    calculateTotal() {
      console.log('calculateTotal')
      let total_discount = 0
      let total_charge = 0
      let total_exportation = 0
      let total_taxed = 0
      let total_exonerated = 0
      let total_unaffected = 0
      let total_free = 0
      let total_igv = 0
      let total_value = 0
      let total = 0
      let total_igv_free = 0

      this.sale_note.items.forEach((row) => {
          total_discount += parseFloat(row.total_discount)
          total_charge += parseFloat(row.total_charge)

          if (row.affectation_igv_type_id === '10') {
              total_taxed += parseFloat(row.total_value)
          }
          if (row.affectation_igv_type_id === '20'  // 20,Exonerado - Operación Onerosa
              || row.affectation_igv_type_id === '21' // 21,Exonerado – Transferencia Gratuita
          ) {
              total_exonerated += parseFloat(row.total_value)
          }
          if (
              row.affectation_igv_type_id === '30'  // 30,Inafecto - Operación Onerosa
              || row.affectation_igv_type_id === '31'  // 31,Inafecto – Retiro por Bonificación
              || row.affectation_igv_type_id === '32'  // 32,Inafecto – Retiro
              || row.affectation_igv_type_id === '33'  // 33,Inafecto – Retiro por Muestras Médicas
              || row.affectation_igv_type_id === '34'  // 34,Inafecto - Retiro por Convenio Colectivo
              || row.affectation_igv_type_id === '35'  // 35,Inafecto – Retiro por premio
              || row.affectation_igv_type_id === '36' // 36,Inafecto - Retiro por publicidad
              || row.affectation_igv_type_id === '37'  // 37,Inafecto - Transferencia gratuita
          ) {
              total_unaffected += parseFloat(row.total_value)
          }
          if (row.affectation_igv_type_id === '40') {
              total_exportation += parseFloat(row.total_value)
          }
          if (['10',
              '20', '21',
              '30', '31', '32', '33', '34', '35', '36',
              '40'].indexOf(row.affectation_igv_type_id) < 0) {
              total_free += parseFloat(row.total_value)
          }
          if (['10',
              '20', '21',
              '30', '31', '32', '33', '34', '35', '36',
              '40'].indexOf(row.affectation_igv_type_id) > -1) {
              total_igv += parseFloat(row.total_igv)
              total += parseFloat(row.total)
          }


          if (['11', '12', '13', '14', '15', '16'].includes(row.affectation_igv_type_id)) {

              let unit_value = row.total_value / row.quantity
              let total_value_partial = unit_value * row.quantity
              row.total_taxes = row.total_value - total_value_partial

              row.total_igv = total_value_partial * (row.percentage_igv / 100)
              row.total_base_igv = total_value_partial
              total_value -= row.total_value

              total_igv_free += row.total_igv
          }

          total_value += parseFloat(row.total_value)

      })

      this.sale_note.total_igv_free = _.round(total_igv_free, 2)

      this.sale_note.total_discount = _.round(total_discount, 2)
      this.sale_note.total_exportation = _.round(total_exportation, 2)
      this.sale_note.total_taxed = _.round(total_taxed, 2)
      this.sale_note.total_taxed_without_rounding = _.round(total_taxed, 5)
      this.sale_note.total_exonerated = _.round(total_exonerated, 2)
      this.sale_note.total_unaffected = _.round(total_unaffected, 2)
      this.sale_note.total_free = _.round(total_free, 2)
      this.sale_note.total_igv = _.round(total_igv, 2)
      this.sale_note.total_value = _.round(total_value, 2)
      this.sale_note.total_taxes = _.round(total_igv, 2)

      this.sale_note.subtotal = _.round(total, 2)
      this.sale_note.total = _.round(total, 2)

      // this.monto_pagar_sin_dcto = this.sale_note.items.reduce((monto_sin_dcto, item) => monto_sin_dcto + item.total_original, 0)
      this.sale_note.monto_pagar_sin_dcto = this.sale_note.items.reduce((monto_sin_dcto, item) => monto_sin_dcto + item.total_original, 0)
    },

    async saveCashDocument(documentId, cashId) {
        const response = await this.$http.post(`/cash/cash_document`, {
            document_id: null,
            sale_note_id: documentId,
            cash_id: cashId,
        })
    },

    recalculatePayments() {
      const count = this.sale_note.payments.length
      const payment = this.sale_note.total
      if (count === 0) return
      const newAmount = parseFloat(parseFloat(payment / count).toFixed(2))
      this.sale_note.payments.forEach(p => {
          p.payment = newAmount
      })
      const diference = Number((payment - (newAmount * count)).toFixed(2))
      if (diference !== 0) {
          this.sale_note.payments[this.sale_note.payments.length - 1].payment += diference
      }
    }

  },


}
</script>


// WEBPACK FOOTER //
// modules/Hotel/Resources/assets/js/views/rooms/partials/ExtendTimeRoom.vue